import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const STORAGE_KEY = "fs_theme";

/** Modo oscuro/claro, persistido en localStorage (preferencia del dispositivo, no de la
 * cuenta). Por defecto arranca en claro; una vez que el usuario cambia, se queda así hasta
 * que él mismo lo vuelva a cambiar. El <html data-bs-theme="..."> ya se fija de entrada con
 * un script inline en public/index.html (antes de que React monte) para evitar el parpadeo
 * de tema claro cuando el usuario ya venía en oscuro. */
export function ThemeProvider({ children }) {
  const [tema, setTema] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
    } catch {
      return "light";
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", tema);
    try {
      localStorage.setItem(STORAGE_KEY, tema);
    } catch {
      // localStorage no disponible (modo privado, etc.) -- el tema sigue funcionando en la sesión.
    }
  }, [tema]);

  const alternarTema = () => setTema((t) => (t === "dark" ? "light" : "dark"));

  return <ThemeContext.Provider value={{ tema, alternarTema }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
